import React, { createRef, useState, useEffect } from "react";
import add from "../../../images/icons/add.png";
import close from "../../../images/icons/close.png";
import edit from "../../../images/icons/edit.png";
import delete_icon from "../../../images/icons/delete.png";
import { Form, Formik } from "formik";
import CustomInput from "../../../components/CustomInput/CustomInput";
import CustomSearchBar from "../../../components/CustomSearchBar/CustomSearchBar";
import CustomButton from "../../../components/CustomButton/custombutton";
import * as Yup from "yup";
import { Box } from "@material-ui/core";
import Table from "../../../components/Table/Table";
import "./role.css";
import AddRoleAcess from "../../../components/AddRole/AddRoleAcess";

import api from "../../../api/api";
import apiUtil from "../../../api/apiUtil";
import getToken from "../../getToken";
import delete_success from "../../../images/icons/deleteRole.png";

const Role = () => {
  const refRoleTable = createRef();
  const [showAddRole, setShowAddRole] = useState(false);
  const [accessValues, setAccessValues] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [detailRole, setDetailRole] = useState(null);
  const [editAccessModules, setEditAccessModules] = useState([]);
  const [isDeleted, setIsDeleted] = useState(false);
  const [keyword, setKeyword] = useState("");

  const [isChecked, setIsChecked] = useState({
    first: false,
    second: false,
    third: false,
    fourth: false,
    fifth: false,
  });

  const [roleList, setRoleList] = useState({
    isLoading: true,
    grouping: false,
    limit: 10,
    data: [],
    total: 10,
    page: 0,
  });

  const clickBtnClose = () => {
    setShowAddRole(false);
    setIsEdit(false);
    setEditAccessModules([]);
    setIsChecked([]);
  };

  const clickAddRole = () => {
    setShowAddRole(true);
    setIsChecked([]);
  };

  const clickDelete = (row) => {
    if (window.confirm("Are you sure you want to delete this role?")) {
      api
        .post(`Admin/DeleteRole?roleId=${row.id}`, {}, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.statusCode === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.value.code === 409) {
                alert(response.data.value.message);
              } else if (response.data.statusCode === 200) {
                alert("Role deleted successfully!");
                setIsDeleted(true);
                retrieveRoleList();
                console.log(response.data);
              } else {
                alert(response.data.message);
              }
            },
            (error, type) => {
              alert(error);
            }
          );
        });
    }
  };

  let brandId = localStorage.getItem("brandId");
  const clickEditRole = (rowData) => {
    console.log(rowData);
    const param = {
      roleId: rowData.id,
      brandId: brandId,
    };
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);

    api.get(`Admin/GetUserRoleById`, param, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.statusCode === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.statusCode === 200) {
            console.log(response.data.value.data.userModules);
            setEditAccessModules(response.data.value.data.userModules);
          } else {
            alert(response.data.message);
          }
        },
        (error, type) => {
          alert(error);
        }
      );
    });

    setIsEdit(true);
    setDetailRole({
      name: rowData.name,
      organizationId: rowData.organizationId,
      description: rowData.description,
      id: rowData.id,
      brandId: rowData.brandId,
    });
  };

  console.log(typeof editAccessModules);
  const [paramRole, setParamRole] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    brandId: brandId,
  });
  const AddRoleFormValidation = Yup.object().shape({
    name: Yup.string().required("Please enter the role name"),
    description: Yup.string().required("Please enter the description"),
  });

  const retrieveRoleList = (value = paramRole) => {
    value.keyword = keyword || "";
    api.post("Admin/GetRoleList", value, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            console.log(response.data);
            setRoleList({
              isLoading: false,
              limit: response.data.data.rowLimit,
              data:
                response.data.data.data && response.data.data.data.length > 0
                  ? response.data.data.data
                  : [],
              total: response.data.data.totalRecords,
              page: response.data.data.paging,
            });
            console.log(roleList);
          } else {
            setRoleList({
              isLoading: false,
              grouping: false,
              limit: 0,
              data: [],
              total: 0,
              page: 0,
            });
          }
        },
        (error, type) => {
          console.log(error);
        }
      );
    });
  };

  const handleSubmitRoleForm = (values, actions) => {
    const param = {
      organizationId: "fc7af43c-a309-11ed-b26e-6045bdd63acb",
      brandId: brandId,
      name: values.name,
      desc: values.description,
      modules: accessValues,
    };
    api.post("Admin/CreateUserRole", param, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data);
          setAccessValues([]);

          if (response.data.code === 200) {
            alert("Role added successfully!!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddRole(false);
            setAccessValues([]);
            setEditAccessModules([]);
            retrieveRoleList();
          } else if (response.data.code === 401) {
            alert(response.data.value.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
            console.log(response.data);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
    });
    actions.setSubmitting(false);
  };

  const handleSubmitEditForm = (values, actions) => {
    const oldModules = editAccessModules.map(module => ({
      moduleName: module.name || module.moduleName,
      accessLevel: module.accessLevel
    }));

    const updatedModules = Array.from(new Set([
      ...accessValues,
      ...oldModules.filter(newModule => {
        return !accessValues.some(oldModule => oldModule.moduleName === newModule.moduleName);
      })
    ]));

    const param = {
      userRoleId: detailRole.id,
      organizationId: detailRole.organizationId,
      brandId: detailRole.brandId,
      name: values.name,
      desc: values.description,
      modules: updatedModules,
    };
    api.post("Admin/UpdateUserRole", param, getToken()).then((result) => {
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response.data);
          setAccessValues([]);
          if (response.data.code === 200) {
            alert("Role updated successfully!!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setIsEdit(false);
            setAccessValues([]);
            setEditAccessModules([]);
            retrieveRoleList();
          } else if (response.data.code === 401) {
            alert(response.data.value.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else {
            alert(response.data.message);
            console.log(response.data);
          }
        },
        (error, type) => {
          alert(error);
          values = {};
        }
      );
    });
    actions.setSubmitting(false);
  };


  const checkBoxList = [
    "Modules Permission",
    "Dashboard",
    "Member",
    // "Blog",
    "Reward (Panel & Mobile)",
    "Reserve (Panel & Mobile)",
    "Point (Mobile)",
    "Menu",
    "Promotion",
    "Notification",
    "Tier Level",
    "Report",
    "Users",
    "Roles",
    "Setting",
    "Contact Us",
    "FAQ",
  ];

  console.log(accessValues);
  useEffect(() => {
    retrieveRoleList();
  }, [paramRole]);

  return (
    <div className="role">
      {(showAddRole || isEdit) && (
        <>
          <div className=" Actions space_between">
            <h6 className="title_text mt-2">
              {showAddRole ? "Add Role" : "Edit Role"}
            </h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <div>
            <Formik
              initialValues={
                isEdit
                  ? detailRole
                  : {
                    name: "",
                    description: "",
                  }
              }
              validateOnBlur={false}
              validationSchema={AddRoleFormValidation}
              onSubmit={(values, actions) => {
                isEdit
                  ? handleSubmitEditForm(values, actions)
                  : handleSubmitRoleForm(values, actions);
              }}
            >
              {({ values, errors, touched, setFieldValue }) => (
                <Form className="row form-container add-role-form">
                  <h6 className="title_text mt-2">Role Information</h6>
                  <div className="col-9">
                    <CustomInput
                      name="name"
                      type="text"
                      label="Name"
                      customclass="input_wrapper"
                      hideicon="true"
                      placeholder="Enter Role Name"
                    />
                  </div>

                  <div className="col-9 mt-3">
                    <CustomInput
                      name="description"
                      label="Description"
                      placeholder="Enter Description"
                      textarea
                    />
                  </div>

                  <div className="col-12 input_wrapper mt-4">
                    {checkBoxList.map((item, index) => (
                      <AddRoleAcess
                        key={item.id}
                        title={item}
                        isChecked={isChecked}
                        setIsChecked={setIsChecked}
                        accessValues={accessValues}
                        setAccessValues={setAccessValues}
                        checkBoxList={checkBoxList}
                        editValues={editAccessModules}
                      />
                    ))}
                  </div>

                  <div className="col-12 mt-3">
                    <div className="Actions justify-content-end">
                      <button
                        type="button"
                        className="button btnCancel"
                        onClick={clickBtnClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="button btnUpdate">
                        {showAddRole ? "Create" : "Update"}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </>
      )}
      {isDeleted && (
        <div className="delete-box">
          <img
            style={{ cursor: "pointer" }}
            onClick={() => setIsDeleted(false)}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                setIsDeleted(false);
              }
            }}
            src={delete_success}
            alt="delete"
          />
          <p>The role has been successfully deleted.</p>

        </div>

      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Role</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveRoleList()}
          />
          {!showAddRole && (
            <CustomButton
              icon={add}
              text="Add Role"
              addIcon={true}
              className="btnAdd"
              onClick={clickAddRole}
            />
          )}
        </div>
      </div>

      <div className="table_container promotion_table role_table">
        <Table
          key={roleList.total}
          ref={refRoleTable}
          maxBodyHeight={roleList.limit * 80}
          isLoading={roleList.isLoading}
          grouping={roleList.grouping}
          limit={roleList.limit}
          page={roleList.page}
          total={roleList.total}
          data={roleList.data}
          onPageChange={(page) => {
            setParamRole({
              ...paramRole,
              currentPage: page,
            });
            retrieveRoleList(paramRole);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex = (roleList.page - 1) * roleList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
            },

            {
              title: "Role Name",
              field: "name",
              width: "236px",
            },
            {
              title: "Description",
              render: (row) => {
                if (row.description.length > 40) {
                  return row.description.substring(0, 39) + "...";
                }
                return row.description;
              },
              width: "316px",
            },
            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickEditRole(row)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => clickDelete(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </div>
  );
};

export default Role;
